$(window).on('load',function () {
	$('#grid').each(function () {
		const grid = document.querySelector('#grid');
		new Masonry( grid, {
			itemSelector: '.project'
		});
	})
});
